import React from "react";
import ElDefectsForm from "./ElDefectsForm";
import { DefectCounter } from "../../ui/buttons/DefectCounter";
import { DefectType } from "../../../types/stringerTypes";

export default function CrossConnectionForm() {
  const renderCounter = (
    defect: DefectType,
    count: number,
    onChange: (delta: number) => void
  ) => <DefectCounter label={defect} count={count} onChange={onChange} />;

  return (
    <ElDefectsForm showDetailsOnly={false} renderCounter={renderCounter} />
  );
}
